export default __webpack_public_path__ + "static/media/my-desk-outline-16px.481749ab.svg";